import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';
import '../assets/css/adminpanel.css';
import '../assets/css/price.css';

const PriceManagement = () => {
    const [price, setPrice] = useState(40); // Default price
    const [newPrice, setNewPrice] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const fetchPrice = async () => {
            try {
                const response = await axiosInstance.get('/board/price');
                setPrice(response.data.price || 40);
            } catch (error) {
                console.error('Error fetching price:', error);
                setErrorMessage('Failed to load the current price.');
            }
        };

        fetchPrice();
    }, []);

    const handleSavePrice = async () => {
        if (!newPrice || newPrice <= 0) {
            setErrorMessage('Please enter a valid price greater than 0.');
            return;
        }

        try {
            const response = await axiosInstance.post('/board/price', { price: Number(newPrice) });
            setPrice(response.data.price);
            setNewPrice('');
            setSuccessMessage('Price updated successfully.');
            setErrorMessage('');
        } catch (error) {
            console.error('Error updating price:', error);
            setErrorMessage('Failed to update the price. Please try again.');
        }
    };

    return (
        <div className="admin-panel container price">
            <header>
                <h2>Manage Price</h2>
                <p>Update the price per square for the fundraiser.</p>
                <nav>
                    <Link to="/admin" className="admin-link">Back to Admin Panel</Link>
                </nav>
            </header>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSavePrice();
                }}
            >
                <div>
                    <label htmlFor="current-price">Current Price:</label>
                    <p id="current-price">${price}</p>
                </div>
                <div>
                    <label htmlFor="new-price">New Price:</label>
                    <input
                        type="number"
                        id="new-price"
                        value={newPrice}
                        onChange={(e) => setNewPrice(e.target.value)}
                        placeholder="Enter new price"
                        min="1"
                        required
                        aria-label="New Price"
                    />
                </div>
                <button type="submit" className="button button-primary">
                    Save Price
                </button>
            </form>
            {successMessage && <p className="success-message">{successMessage}</p>}
            {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>
    );
};

export default PriceManagement;